module.exports = __webpack_public_path__ + "img/mobileladdercontrol5.428f3e81.png";